// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__2IR1f","footer":"ModalUpdate_footer__e1Meb"};